import React, { type JSX } from "react";
import styled from "styled-components";
import { Main, Text } from "styles/themeColors";
import { WarningRounded } from "@mui/icons-material";
import Icon from "view/Icon";

const Container = styled.div<{ type: 'warning' | 'error'; margin: string }>`
  display: flex;
  flex-direction: row;
  gap: 5px;
  border-radius: 6px;
  padding: 5px 10px;
  margin: ${({ margin }) => margin};
  background-color: ${({ type }) =>
    type === 'error' ? Main.white : Main.lightYellow};
  border: 1px solid
    ${({ type }) => (type === 'error' ? Main.error2 : Main.brandDark)};
`;

const WarningText = styled.div<{ fontSize: string; type: 'warning' | 'error' }>`
  font-size: ${({ fontSize }) => fontSize};
  color: ${Text.primary};
`;

interface Props {
  message: JSX.Element | string;
  fontSize?: string;
  margin?: string;
  type?: 'warning' | 'error';
}

const WarningBanner = ({
  message,
  fontSize = "16px",
  margin = "0px",
  type = "warning",
}: Props) => {
  let icon: JSX.Element;

  switch (type) {
    case "error":
      icon = <Icon name="Error" className="error-icon-banner" />;
      break;
    case "warning":
    default:
      icon = <WarningRounded style={{ color: Main.warning }} />;
      break;
  }

  const renderMessage = () => {
    if (typeof message === "string") {
      return message.split("\n").map((line, index) => (
        <span key={index}>
          {line}
          {index < message.split("\n").length - 1 && <br />}
        </span>
      ));
    }
    return message;
  };

  return (
    <Container type={type} margin={margin}>
      {icon}
      <WarningText fontSize={fontSize} type={type}>
        {renderMessage()}
      </WarningText>
    </Container>
  );
};

export default WarningBanner;
